import { ConfigurationSchema } from '@jbrowse/core/configuration';
/**
 * #config LinearGCContentDisplay
 */
export default function WiggleConfigFactory(pluginManager) {
  return ConfigurationSchema('LinearGCContentDisplay', {}, {
    /**
     * #baseConfiguration
     */
    baseConfiguration: pluginManager.getDisplayType('LinearWiggleDisplay').configSchema,
    explicitlyTyped: true
  });
}